import React from 'react';
import { TabPanelContextType } from './types';

const TabPanelContext = React.createContext<TabPanelContextType | undefined>(
  undefined,
);

export default TabPanelContext;
